var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimedBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00033 0.75C4.74516 0.75 2.91699 2.57817 2.91699 4.83333C2.91699 7.0885 4.74516 8.91667 7.00033 8.91667C9.25549 8.91667 11.0837 7.0885 11.0837 4.83333C11.0837 2.57817 9.25549 0.75 7.00033 0.75ZM11.167 17.25C12.5017 17.25 13.5837 16.168 13.5837 14.8333C13.5837 12.5782 11.7555 10.75 9.50032 10.75H4.50033C2.24516 10.75 0.416992 12.5782 0.416992 14.8333C0.416992 16.168 1.49897 17.25 2.83366 17.25H11.167Z",
    fill: "#273C49"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimedBy);
export default __webpack_public_path__ + "static/media/claimed-by.71ef5f2297e35447d19cbcbe20664daf.svg";
export { ForwardRef as ReactComponent };